/* eslint-disable no-console */
import React, { createContext, useContext, useReducer, useRef, useState } from 'react';
import { LanguageContext } from '../../libs/Context';
import { Box, Tab, Tabs } from '@mui/material';
import { RiDeleteBinLine, RiImageEditLine } from 'react-icons/ri';
import { AiOutlineShareAlt } from 'react-icons/ai';
import { BsFolder } from 'react-icons/bs';
import mediaDriveReducer, { initialState } from './mediaDriveReducer';
import { useNavigate, useParams } from 'react-router-dom';
import ListGridViews from './components/ListGridViews';
import MediaTopButtons from './components/MediaTopButtons';
import FilterMenu from './components/CustomMenu/FilterMenu';
// import FolderMenu from './components/CustomMenu/FolderMenu';
import FolderMenuNew from './components/CustomMenu/FolderMenuNew';
import FileExistPopup from './Common/FileExistPopup';
import useUploadFiles from './customHooks/useUploadFiles';
import useUploadFolder from './Common/UploadFolder/UseUploadFolder';
import CoustomSearch from './Common/CoustomSearch';
import { useSelector } from 'react-redux';
import TemplatesSvg from '../../assets/SvgComponents/TemplatesSvg';
import { roleCondition } from '../../libs/HelperContent';
import LicenseSubscriptions from '../LicenseSubscription';
import useGetComponentName from '../../libs/CustomHooks/useGetCompInfo';
import MediaDriveIcon from '../../assets/SideNavIcons/Media_Drive.svg';
import Loading from '../../components/Common/Loaders/FullWidthLoader/Loading';

export const MediaContext = createContext<any>({});
const MediaDrive = () =>
{
	const { language } = useContext(LanguageContext);
	const [ mediaState, setMediaState ] = useReducer(mediaDriveReducer, initialState);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ creatLoading, setCreatLoading ] = useState<any>(false);
	const [ clickedData, setClickedData ] = useState<any>({});
	const tabVal = useParams();
	const [ tab, setTab ] = useState<number>(tabVal
		? (tabVal?.tab === 'shared' ? 1 : tabVal?.tab === 'employee' ? 2 : tabVal?.tab === 'trash' ? 3 : tabVal?.tab === 'template' ? 4 : 0)
		: 0);
	const navigate = useNavigate();
	const [ open, setOpen ] = useState(false);
	const componentName = useGetComponentName(7);
	const handleTabchange = (e:any, newVal:any) =>
	{
		navigate(`/drive/${e.target.dataset.tab ?? 'folder'}`);
		setTab(Number(e.target.dataset.tab ? newVal : 0));
		setMediaState({ type: 'tabChange' });
	};

	const [ openFileExist, setOpenFileExist ] = useState(false);
	const [ progress, setProgress ] = useState<boolean>(false);
	const isPausedRef = useRef({ wait: false, replace: '' });
	const pauseFunction = () =>
	{
		setProgress(false);
		setOpenFileExist(true);
		isPausedRef.current = { wait: true, replace: 'cancel' };

		return new Promise((resolve) =>
		{
			const interval = setInterval(() =>
			{
				if (!isPausedRef.current.wait)
				{
					setOpenFileExist(false);
					clearInterval(interval);
					resolve({ replace: isPausedRef.current.replace });
				}
			}, 1000);

			setTimeout(() =>
			{
				clearInterval(interval);
				setOpenFileExist(false);
				resolve({ replace: 'cancel' });
			}, 60000);
		});
	};

	const { uploadFilesFunc } = useUploadFiles(pauseFunction, clickedData, setMediaState,
		setProgress);
	const uploadFolderFunc = useUploadFolder(pauseFunction, clickedData, setMediaState,
		setProgress);

	return (
		<MediaContext.Provider value={{ mediaState,
			setMediaState,
			tab,
			uploadFilesFunc,
			creatLoading,
			setCreatLoading,
			clickedData,
			setClickedData }}
		>
			<>
				{progress && <Loading/>}
				<div className='flexRow respdngSM alignCntr whiteBg positionStickySM resHeaderHeight'>
					<div className='flexAutoRow alignCntr respdngHSM lineHightBtn'>
						<div className='flexInline imgAvatarXXXS'>
							<img src={MediaDriveIcon}/>
						</div>
						<span className='subHeadingSM pdngLXS capitalTxt'>{componentName}</span>
					</div>
					<div className='flexMinWidthRow respdngHSM justifyEnd'>
						<div className={'flexAutoRow  '} >
							<CoustomSearch tab={tab}/>
						</div>
					</div>
				</div>
				<div className='flexCol respdngHSM minHeight90'>
					<div className='flexAutoCol '>
						<div className='flexRow respdngHSM'>
							<Box sx={{ width: 'var(--percent100)' }}>
								<Tabs
									value={tab}
									onChange={handleTabchange}
									id='mediakit_Tab'
									variant='scrollable'
									scrollButtons='auto'
									aria-label='basic tabs example'
									className='flexRow brdrBSM'
									allowScrollButtonsMobile
								>
									<Tab
										iconPosition='start'
										label={language?.myFiles}
										value={0}
										data-tab='folder'
										icon={<BsFolder className='' data-tab='folder' fontSize={'var(--pixel24)'}/>}
									/>
									{roleCondition(userData?.empRole) &&
									<Tab
										iconPosition='start'
										label={language?.myTemplate}
										value={4}
										data-tab='template'
										icon={<span className={`${tab === 4 ? 'invertPrimary' : ''} imageAvatarXXS `}><TemplatesSvg data-tab='template'/></span>}
									/>}
									<Tab
										iconPosition='start'
										label={language?.sharedWithMe}
										value={1}
										data-tab='shared'
										icon={<AiOutlineShareAlt data-tab='shared' className='' fontSize={'var(--pixel24)'}/>}
									/>
									{userData?.empRole === 'superAdmin' &&
									<Tab
										iconPosition='start'
										label={language?.employee}
										value={2}
										data-tab='employee'
										icon={<RiImageEditLine data-tab='employee' className=''fontSize={'var(--pixel24)'} />}
									/>
									}
									<Tab
										iconPosition='start'
										label={language?.trash}
										value={3}
										data-tab='trash'
										icon={<RiDeleteBinLine data-tab='trash' fontSize={'var(--pixel22)'} />}
									/>
								</Tabs>
							</Box>
						</div>
						<MediaTopButtons clickedData={clickedData} />
					</div>
					<ListGridViews
						userData={userData}
						setClickedData={setClickedData}
						clickedData={clickedData}
						mediaState={mediaState}
					/>
					{mediaState?.menuItems?.create === 1 &&
					// <FolderMenu // Upload File Only
					<FolderMenuNew // Upload File and DragDrop
						tab={tab}
						uploadFilesFunc={uploadFilesFunc}
						uploadFolderFunc={uploadFolderFunc}
						menuItem={mediaState?.menuItems}
						anchorEl={mediaState?.menuItems?.create === 1}
						setOpen={setOpen}
					/>}
					{mediaState?.menuItems?.toggleFilter === 1 &&
					<FilterMenu
						menuItem={mediaState?.menuItems}
						setMenuItem={setMediaState}
						anchorEl={mediaState?.menuItems?.toggleFilter === 1}
						tab={tab} filter={mediaState?.filter}
					/>
					}
					{openFileExist &&
					<FileExistPopup openDialog={openFileExist} isPausedRef={isPausedRef}
						setProgress={setProgress}
					/>
					}

					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setOpen(!open); }} className={open ? 'overlaySlider fadeInOverlay' : ''} onClick={() => setOpen(!open)} />
					<div className={open ? 'flexCol fxdSociallicense slideIn' : 'flexCol fxdSociallicense '} >
						{open &&
						<LicenseSubscriptions
							openslider={open}
							setOpenPlanSlider={setOpen}
						/>
						}
					</div>
				</div>
			</>
		</MediaContext.Provider>
	);
};

export default MediaDrive;